import { useVisibilityPublicApi } from './useVisibilityPublicApi';
import { useCacheInvalidationPublicApi } from './useCacheInvalidationPublicApi';
import { useBookmarksPublicApi } from './useBookmarksPublicApi';
export const usePublicApi = () => {
  useVisibilityPublicApi();
  useCacheInvalidationPublicApi();
  useBookmarksPublicApi();
};